import { z } from 'zod';

/**
 * A repeated value carried as a single comma-separated query param
 * (`?param=a,b,c`). Absent or blank (`?param=`) normalises to an empty array,
 * which list endpoints treat as "no filter" — keeping the parsed value a plain
 * non-nullable array. One source of truth for every comma-separated list param
 * (Standort narrow sets, lead status/source filters, …) so the shape can't
 * drift per contract.
 */
export const commaSeparated = <T extends z.ZodType<string, string>>(item: T) =>
  z
    .string()
    .optional()
    .transform((value) => (value === undefined || value === '' ? [] : value.split(',')))
    .pipe(z.array(item));
